module.exports = __webpack_public_path__ + "assets_app/img/logo-vlechtmuseum.3e39ce42.svg";